export const LOG_LOCATION = 'spa-apps.common.redirect.jira-base-routing';
